import { MetaType, AssetRef } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "word_banks"

export type WordBank = {
  kind: typeof kind
  version: number
  type: "word-bank"
  assets: Array<AssetRef>
  meta: MetaType
  words: string[]
}

export const reducerAction = {
  meta: actionCreatorGuard<WordBank, MetaType>("meta", kind),
  assets: actionCreatorGuard<WordBank, Array<AssetRef>>("assets", kind),
  type: actionCreatorGuard<WordBank, string>("type", kind),
  words: actionCreatorGuard<WordBank, string[]>("words", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    WordBank,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const wordBankAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const wordBankReducer = reducerGuard<WordBank>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  .case(...reducerAction.words)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<WordBank, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )
    }

    return prevState
  })
